export const twoDecimalsFilter = (num: number | string): string => (+num).toFixed(2);

export const noDecimalsFilter = (num: number | string): string => (+num).toFixed();

export const thousandsSeparatorFilter = (num: number | string): string =>
  num.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatPrice = (
  num: number | string | null | undefined,
  currencySymbol: string = '£'
): string => `${currencySymbol}${twoDecimalsFilter(num ?? 0)}`;
